export default __webpack_public_path__ + "static/media/thumbnail-about.0fa4b97b.png";